import React, { useEffect, useState } from 'react';
import { useSubscription } from '@apollo/client';
import Modal from '../../../components/Modal';
import { CHIMONEY_PAYMENT_SUBSCRIPTION } from '../../../graphql/mutation';
import styles from './InteracPaymentPreviewModal.module.scss';
import Loader from '../../../components/Loader';
import ResponseModal from '../../global/ResponseModal';
import PaymentinProgressIcon from '../../../assets/svg_components/PaymentinProgressIcon';

type Props = {
  transactionId: string;
  onSuccess: any;
  onClose: any;
};

const InteracModalPaymentProcess = ({ transactionId, onSuccess, onClose }: Props) => {
  const { data } = useSubscription(CHIMONEY_PAYMENT_SUBSCRIPTION, {
    variables: {
      transactionId
    }
  });

  const [showInProgressModal, setShowInProgressModal] = useState(false);

  useEffect(() => {
    if (
      data?.chimoneyTransaction?.status === 'success' &&
      data?.chimoneyTransaction?.reference === transactionId
    ) {
      onSuccess();
    }
  }, [data]);

  // set interval to close out after 5mins
  useEffect(() => {
    setTimeout(() => {
      setShowInProgressModal(true);
    }, 60000);
  }, []);

  if (showInProgressModal) {
    return (
      <ResponseModal
        isShow
        isShowCloseIcon={false}
        icon={<PaymentinProgressIcon />}
        onClose={() => {}}
        onClickAway={() => {}}
        onBack={() => {}}
        title="Payment is being processed"
        subTitle="Your payment is currently being processed. You will be sent an email to confirm the status of your transaction."
        btnTitle="Close"
        onPress={() => {
          onClose();
        }}
      />
    );
  }

  return (
    <Modal
      isShow
      isShowBackButton={false}
      onClose={() => {}}
      isShowCloseIcon={false}
      onClickAway={() => {}}
      onBack={() => {}}
      className={styles.InteracDetailModal}
      contentClassName={styles.InteracDetailModal__processingcontent}
      isShowBottomLogo={false}>
      <h6 className={styles.InteracDetailModal__processingtitle}>Payment processing</h6>
      <Loader />
    </Modal>
  );
};

export default InteracModalPaymentProcess;
